import { connect } from '@atlassian/jira-react-redux';
import { getBlueprintModuleKeys } from '../../../../../state/selectors/blueprint';
import type { State } from '../../../../../state/types';
import BlueprintOption from '../common/blueprint-option';
import BlueprintList from './view';

const mapStateToProps = (state: State) => ({
	blueprintModuleKeys: getBlueprintModuleKeys(state),
	BlueprintOptionComponent: BlueprintOption,
});

export default connect(mapStateToProps, {})(BlueprintList);
